import React from'react'

import * as css from './Fondos.css'

let PropTypes = React.PropTypes

export class Totales extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            fondoPendiente: 0
        }
        this.onFondoPendienteChange = (evt)=>{
            this.setState({fondoPendiente: evt.target.value}, ()=>this.context.saldoLiderChange(this.state.fondoPendiente))
        }
    }
    render() {
        return (
            <div className={"panel panel-info "+css.panelTotales}>
                <div className={"panel-heading "+css.panelHeadingDetalle}>
                    <b>Totales</b>
                </div>
                <div className={"panel-body "+css.panelBodyTotales}>
                    <div className="col-md-7">
                        <label>Viaticos</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.viaticosLiquidacion.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                    <div className="col-md-7">
                        <label>Fondo por Rendir</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.fondosRendir.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                    <div className="col-md-7">
                        <label>Saldo Lider</label>
                    </div>
                    <div className="col-md-5">
                        <input type="number" className={"form-control "+css.inputFondos}
                            ref={(fondoPendiente) => { this.inputFondoPendiente = fondoPendiente }}
                            onFocus={()=>{ this.inputFondoPendiente.select() }}
                            value={this.props.totales.fondoPendiente}
                            onChange={this.onFondoPendienteChange}/>
                    </div>
                    <div className="col-md-7">
                        <label>Saldo por Girar</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.fondoGirar.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                </div>
            </div>
        )
    }
}
Totales.contextTypes ={
    saldoLiderChange: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/asignacion-fondos/Totales.jsx